import React from "react";
import Menu from "../components/Menu";
import Header from "../components/Header";
import Main from "../components/Main";
import "../styles/Home.css";

function Home() {
    return (
        <div className="home">
        <Menu />
        <Header />
        <Main />

        </div>
    );
    }

export default Home;